import Component from "../../component";

export const RewardsNavbarItemConfig = {
    signature: 'rewardsNavbarItem',
    baseHtmlClass: 'rewards_navbar_item',
    selector: '.rewards_navbar_item',
    initedHtmlClassModifier: 'inited',
    isOpenHtmlClassModifier: 'open',

    rewardsRootElementSelector: 'stamped-rewards-init',
    rewardsWindowElementSelector: '.stamped-rewards-base',
    rewardsWindowOpenedClass: 'opened',

    stageBaseHtmlClass: 'rewards_navbar_item_stage',
    stageOpenHtmlClassModifier: 'open',
};

export class RewardsNavbarItem extends Component {

    static applyToAll(toggleFunction) {
        document.querySelectorAll(RewardsNavbarItemConfig.selector).forEach((element) => {
            if (RewardsNavbarItem.isElementComponentized(element, RewardsNavbarItemConfig.signature)) return;
            new RewardsNavbarItem(element, toggleFunction);
        });
    }

    constructor(id_or_element, toggleFunction, props = {}) {
        super({
            element: id_or_element,
            config: RewardsNavbarItemConfig
        });

        // The function to call to toggle the rewards launcher UI visibility.
        this.toggleFunction = toggleFunction || this.fallbackToggleFunction;

        this.rewardsRootElement = getRewardsRootElement();
        this.rewardsWindowElement = this.getRewardsWindowElement();

        this.element.addEventListener('click', this.handleClick.bind(this));

        this.stageOpenHtmlClass = `${ RewardsNavbarItemConfig.stageBaseHtmlClass}--${ RewardsNavbarItemConfig.stageOpenHtmlClassModifier }`;
        this.stageElement = null;
        if (this.rewardsWindowElement) {
            const mutationConfig = { attributes: true, childList: false, subtree: false };
            new MutationObserver(this.handleMutation.bind(this)).observe(this.rewardsWindowElement, mutationConfig);
            this.stageElement = this.createStageElement();
        }

        this.isOpen = this.extractOpenState();
        this.inited = true;
        this.render();
    }


    handleClick() {
        event.preventDefault();
        this.toggleFunction();
        this.isOpen = this.extractOpenState();
        this.render();
    }

    handleMutation(mutations, observer){
        this.isOpen = this.extractOpenState();
        this.render();
    }

    fallbackToggleFunction() {
        console.warn(`[${RewardsNavbarItemConfig.signature}] No toggleFunction provided`);
    }

    render() {
        this.conditionallySetHtmlClassState(this.inited, RewardsNavbarItemConfig.initedHtmlClassModifier);
        this.conditionallySetHtmlClassState(this.isOpen, RewardsNavbarItemConfig.isOpenHtmlClassModifier);
        this.isOpen ? this.showStageElement() : this.hideStageElement();
    }

    extractOpenState() {
        if (!this.rewardsWindowElement) return false;
        return this.rewardsWindowElement.classList.contains(RewardsNavbarItemConfig.rewardsWindowOpenedClass);
    }

    getRewardsWindowElement() {
        if (!this.rewardsRootElement) return;
        return this.rewardsRootElement.querySelector(RewardsNavbarItemConfig.rewardsWindowElementSelector)
    }

    createStageElement() {
        if (!this.rewardsWindowElement) return;
        const stageElement = createStateElement();
        this.rewardsWindowElement.parentElement.appendChild(stageElement);
        return stageElement;
    }

    showStageElement() {
        if (!this.stageElement) return;
        this.stageElement.classList.add(this.stageOpenHtmlClass);
    }

    hideStageElement() {
        if (!this.stageElement) return;
        this.stageElement.classList.remove(this.stageOpenHtmlClass);
    }

}

function getRewardsRootElement() {
    return document.getElementById(RewardsNavbarItemConfig.rewardsRootElementSelector);
}

function createStateElement() {
    let element = document.createElement('div');
    const htmlClass = `${ RewardsNavbarItemConfig.stageBaseHtmlClass }`;
    element.setAttribute("class", htmlClass);
    return element;
}